import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import UsersEdit from './usersEdit';
import UsersForm from './usersForm';
import UsersIndex from './usersIndex';
import accessRequestApprovalModalTemplate from './accessRequestApprovalModal.jade';

export default angular.module('app.components.admin.users', [
  'ui.router',
  'angularModalService',
  UsersEdit.name,
  UsersForm.name,
  UsersIndex.name
])
  .config(function($stateProvider, $urlRouterProvider){
    $stateProvider
      .state('app.admin.users', {
        abstract: true,
        url: '/users',
        template: '<ui-view/>'
      })
      .state('app.admin.users.index', {
        url: '',
        template: '<users-index></users-index>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.admin.users.index');
          }
        }
      })
      .state('app.admin.users.new', {
        url: '/new',
        template: '<users-edit></users-edit>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.admin.users.new');
          }
        }
      })
      .state('app.admin.users.edit', {
        url: '/:id',
        template: '<users-edit></users-edit>',
        resolve: {
          $title: ($filter, $stateParams, UsersResource) => {
            return UsersResource.one($stateParams.id).get()
              .then((user) => {
                let name = `${user.first_name} ${user.last_name}`;
                return $filter('translate')('$state.app.admin.users.edit', {name})
              });
          }
        }
      })
      .state('app.admin.users.edit.accessRequest', {
        url: '/access-requests/:accessRequestId',
        onEnter: /* @ngInject */ function ($stateParams, $state, ModalService, UserAccessRequestsResource, notify) {
          const userId = $stateParams.id;
          const requestId = $stateParams.accessRequestId;
          const backToEdit = () => $state.go('app.admin.users.edit', {id: userId});

          UserAccessRequestsResource.one(requestId).get().then((req) => {
            const mainEl = document.querySelector('.js-primary-main .c-panel') || document.querySelector('.js-primary-main');
            if (mainEl && window.getComputedStyle(mainEl).position === 'static') {
              mainEl.style.position = 'relative';
            }
            const modalOptions = {
              template: accessRequestApprovalModalTemplate(),
              controllerAs: 'vm',
              controller: function (request, close) {
                this.request = request;
                this.msgParams = {email: request.requester_email, developer: request.game_developer_name};
                this.close = close;
              },
              inputs: {request: req}
            };
            if (mainEl) {
              modalOptions.appendElement = angular.element(mainEl);
            }
            ModalService.showModal(modalOptions).then((modal) => {
              modal.close.then((action) => {
                if (action === 'approve') {
                  UserAccessRequestsResource.one(requestId).customPOST(null, 'approve')
                    .then(() => notify.success('accessApproved')).catch(notify.apiError).finally(backToEdit);
                } else if (action === 'reject') {
                  UserAccessRequestsResource.one(requestId).customPOST(null, 'reject')
                    .then(() => notify.success('accessRejected')).catch(notify.apiError).finally(backToEdit);
                } else {
                  backToEdit();
                }
              });
            });
          }).catch((err) => {
            notify.apiError(err);
            backToEdit();
          });
        }
      });
  })


/** WEBPACK FOOTER **
 ** ./src/components/admin/users/users.js
 **/